export default __webpack_public_path__ + "static/2-765bae590b2db2cc645e97f2927aca57.png";